import { gql } from '@apollo/client';
import { ADDRESS_FRAGMENT, RestAddress, RestAddressInput } from '../fragments.rest';

export type ValidateAddressQuery = {
  validateAddress: {
    __typename: 'RestValidateAddress';
    data: RestAddress[];
  };
};

export type ValidateAddressQueryVariables = {
  input: RestAddressInput;
};

export const VALIDATE_ADDRESS_QUERY = gql`
  query ValidateAddressQuery($input: RestAddressInput) {
    validateAddress(input: $input)
      @rest(
        type: "RestValidateAddress"
        endpoint: "user"
        path: "/addresses/validate"
        method: "POST"
      ) {
      data @type(name: "RestAddress") {
        ...AddressFragment
      }
    }
  }
  ${ADDRESS_FRAGMENT}
`;
